export const MODULE_NAME = 'Contractors'

export const paths = {
  Contractors: '/contractors',
}
